import {Component, inject, OnInit} from '@angular/core';
import {ViewService} from '../../../../../shared/service/view.service';
import {Button} from 'primeng/button';
import {SwitchComponent} from '../../../../../shared/common/switch/switch.component';
import {InputNumberComponent} from '../../../../../backend/generic/input-number/input-number.component';
import {PlayerSessionService} from '../../../../service/player-session.service';
import {RestErrorHelper} from '../../../../../../helper/rest-error-helper';
import {PlayerProfileService} from '../../../../service/player-profile.service';
import {Popover} from 'primeng/popover';
import {PlayerProfile} from '../../../../model/player-profile';
import {PrimeTemplate} from 'primeng/api';
import {NgTemplateOutlet} from '@angular/common';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {RouterLink} from '@angular/router';
import {DropdownDomainComponent} from '../../../../../shared/common/dropdown-domain/dropdown-domain.component';
import {
  DOMAIN_VALUE_CD_DART_TYPE_EDART,
  DOMAIN_VALUE_CD_DART_TYPE_STEELDART,
  DOMAIN_VALUES_DART_TYPE,
  Domains,
} from '../../../../../../../assets/domains/domains';
import {DomainValue} from '../../../../../../model/DomainValue';

@Component({
  selector: 'app-player-profile-calendar-notification',
  imports: [
    Button,
    SwitchComponent,
    InputNumberComponent,
    Popover,
    PrimeTemplate,
    NgTemplateOutlet,
    TranslatePipe,
    RouterLink,
    DropdownDomainComponent
  ],
  templateUrl: './player-profile-calendar-notification.component.html',
  styleUrl: './player-profile-calendar-notification.component.scss'
})
export class PlayerProfileCalendarNotificationComponent implements OnInit
{
  public view = inject(ViewService);
  public playerSessionService = inject(PlayerSessionService);
  private restErrorHelper = inject(RestErrorHelper);
  private playerProfileService = inject(PlayerProfileService);
  private translate = inject(TranslateService);

  isSaving: boolean;

  mobileView: boolean;
  playerProfile: PlayerProfile;
  eventNotificationActive: boolean;
  eventNotificationRadius: number;
  dartTypePreferenceCd: string;
  dartTypeValues: DomainValue[];

  ngOnInit(): void
  {
    this.mobileView = true;
    this.initData();
  }

  private initData(): void
  {
    this.playerProfile = this.playerSessionService.playerProfileObject;
    this.eventNotificationActive = this.playerProfile?.notifyTournaments;
    this.eventNotificationRadius = this.playerProfile?.notifyTournamentsRadius;
    this.dartTypePreferenceCd = this.playerProfile?.dartTypePreferenceCd ?? '';

    this.dartTypeValues = Domains.initializeListWithAllAndValues(DOMAIN_VALUES_DART_TYPE, this.translate);
  }

  public saveSettings(): void
  {
    this.isSaving = true;

    const dartTypePreferenceCd = (this.dartTypePreferenceCd === DOMAIN_VALUE_CD_DART_TYPE_STEELDART ||
      this.dartTypePreferenceCd === DOMAIN_VALUE_CD_DART_TYPE_EDART) ? this.dartTypePreferenceCd : '';

    const body = {
      notifyTournaments: this.eventNotificationActive,
      notifyTournamentsRadius: this.eventNotificationRadius ?? 0,
      dartTypePreferenceCd
    };

    this.playerProfileService.updateProfileField(body, true).subscribe({
      next: data =>
      {
        console.log('Einstellungen gespeichert', data);
        this.isSaving = false;
      },
      error: error =>
      {
        this.isSaving = false;
        this.restErrorHelper.handleErrorService(error);
        this.initData();
      }
    });
  }
}
